import React from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    alignItems: "center",
    minHeight: 64,
    backgroundColor: theme.palette.background.paper,
    flex: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 2px 12px rgba(26,18,52,.035)",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      rowGap: 0,
      paddingBottom: 3,
    },
  },
  backButton: {
    minWidth: 42,
    width: 42,
    marginLeft: 5,
    borderRadius: 11,
    [theme.breakpoints.up("md")]: { display: "none" },
  },
}));

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleBack = () => {
    history.push("/tickets");
  };

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Card square className={classes.ticketHeader}>
          <Button color="primary" onClick={handleBack} className={classes.backButton} aria-label="Volver a conversaciones">
            <ArrowBackIos />
          </Button>
          {children}
        </Card>
      )}
    </>
  );
};

export default TicketHeader;
